<template>
  <div style="height: 100%;" class="modal-HealthInfo">
    <el-form :model="addForm" ref="addForm" :disabled='disabled'>
      <el-row>
        <el-card>

          <div slot="header" class="clearfix">
            <span>身体情况</span>
          </div>
          <el-col :span="6" class="item">
            <el-form-item label="症状">
              <el-input placeholder="请输入症状" v-model="addForm.symptom" maxlength="11" clearable
                  style="width:200px;margin-right:10px"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="18" class="item">

            <el-form-item label="详情">
            <el-input placeholder="请输入详情"
                      v-model="addForm.symptomInfo" :rows="6" type="textarea"
                      style="margin-right:10px"></el-input>
            </el-form-item>


          </el-col>

        </el-card>
        <el-card>

          <div slot="header" class="clearfix">
            <span>一般情况</span>
          </div>

          <el-col :span="6" class="item">
            <el-form-item label="体温">
              <el-input v-model="addForm.temperature" placeholder="请输入体温" clearable>
                <template slot="append">℃</template>
              </el-input>

            </el-form-item>

            <el-form-item label="呼吸频率">
              <el-input v-model="addForm.respiratory" placeholder="请输入呼吸频率" clearable>
                <template slot="append">次/分钟</template>
              </el-input>
            </el-form-item>

            <el-form-item label="身高">
              <el-input v-model="addForm.stature" placeholder="请输入身高" clearable>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>

            <el-form-item label="体重">
              <el-input v-model="addForm.weight" placeholder="请输入体重" clearable>
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>


          </el-col>

          <el-col :span="6" class="item">

            <el-form-item label="体质指数">
              <el-input v-model="addForm.constitution" placeholder="请输入体质指数" clearable>
                <template slot="append">kg/m²</template>
              </el-input>
            </el-form-item>


            <el-form-item label="脉率">
              <el-input v-model="addForm.pulseRate" placeholder="请输入脉率" clearable>
                <template slot="append">次/分钟</template>
              </el-input>
            </el-form-item>

            <el-form-item label="左侧血压">
              <el-input v-model="addForm.bloodPressureLeft" placeholder="请输入左侧血压" clearable>
                <template slot="append">mmHg</template>
              </el-input>
            </el-form-item>

            <el-form-item label="右侧血压">
              <el-input v-model="addForm.bloodPressureRight" placeholder="请输入右侧血压" clearable>
                <template slot="append">mmHg</template>
              </el-input>
            </el-form-item>


          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="臀围">
              <el-input v-model="addForm.hipLine" placeholder="请输入臀围" clearable>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>

            <el-form-item label="腰围">
              <el-input v-model="addForm.waistLine" placeholder="请输入腰围" clearable>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>

            <el-form-item label="腰臀围比值">
              <el-input v-model="addForm.whr" placeholder="请输入腰围" clearable>
              </el-input>
            </el-form-item>

            <el-form-item label="自理能力评价">
              <el-input v-model="addForm.selfCareAbility" placeholder="请输入自理能力评价" clearable>
              </el-input>
            </el-form-item>


          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="健康状况评价">
              <el-input v-model="addForm.healthStatus" placeholder="请输入健康状况评价" clearable>
              </el-input>
            </el-form-item>

            <el-form-item label="认知功能">
              <el-input v-model="addForm.cognitive" placeholder="请输入认知功能" clearable>
              </el-input>
            </el-form-item>

            <el-form-item label="情感状态">
              <el-input v-model="addForm.emotionStates" placeholder="请输入情感状态" clearable>
              </el-input>
            </el-form-item>

          </el-col>


        </el-card>

        <el-card>
          <div slot="header" class="clearfix">
            <span>生活方式</span>
          </div>

          <el-col :span="24" class="item">

            <el-col :span="2" class="item">
              <div class="occupationalDiseases">
                职业病
              </div>
            </el-col>

            <el-col :span="15" class="item">
              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="从业时间">
                    <el-input v-model="addForm.workingTime" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>

              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="职业病情况">
                    <el-input v-model="addForm.occupationalDiseases" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="职业工种">
                    <el-input v-model="addForm.occupationalDiseasesType" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="粉尘">
                    <el-input v-model="addForm.dust" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12" class="item">
                  <el-form-item label="防护措施">
                    <el-input v-model="addForm.dustSafeguard" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>


              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="放射物质">
                    <el-input v-model="addForm.radiogen" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="防护措施">
                    <el-input v-model="addForm.radiogenSafeguard" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="物流因素">
                    <el-input v-model="addForm.logistics" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="防护措施">
                    <el-input v-model="addForm.logisticsSafeguard" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="化学物质">
                    <el-input v-model="addForm.chemistry" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="防护措施">
                    <el-input v-model="addForm.chemistrySafeguard" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="其他">
                    <el-input v-model="addForm.occupationalDiseasesElse" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="防护措施">
                    <el-input v-model="addForm.occupationalDiseasesElseSafeguard" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

            </el-col>
          </el-col>


          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="oral">
                口腔
              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="口唇">
                    <el-input v-model="addForm.lip" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="齿列">
                    <el-input v-model="addForm.tooth" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="咽部">
                    <el-input v-model="addForm.pharynx" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

            </el-col>


          </el-col>

          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="vision">
                视/听力
              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="左眼视力">
                    <el-input v-model="addForm.leftVision" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="右眼视力">
                    <el-input v-model="addForm.rightVision" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="矫正左眼视力">
                    <el-input v-model="addForm.adjustLeftVision" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12" class="item">
                  <el-form-item label="矫正右眼视力">
                    <el-input v-model="addForm.adjustRightVision" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="听力">
                    <el-input v-model="addForm.hearing" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12" class="item">
                  <el-form-item label="运动能力">
                    <el-input v-model="addForm.athletic" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-col>
          </el-col>


        </el-card>


        <el-card>
          <div slot="header" class="clearfix">
            <span>查体</span>
          </div>
          <el-col :span="24" class="item">
            <el-col :span="2" class="item">
              <div class="label">

              </div>
            </el-col>
            <el-col :span="15" class="item">
              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="皮肤">
                    <el-input v-model="addForm.skin" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="巩膜">
                    <el-input v-model="addForm.sclera" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-col>
          </el-col>


          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="lung">
                肺
              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="桶装胸">
                    <el-input v-model="addForm.barrelChest" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="呼吸音">
                    <el-input v-model="addForm.breathSounds" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="罗音">
                    <el-input v-model="addForm.rale" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>

              </el-col>

            </el-col>
          </el-col>

          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="heart">
                心脏
              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="心率">
                    <el-input v-model="addForm.heartRate" placeholder="请输入" clearable>
                      <template slot="append">次/分钟</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="杂音">
                    <el-input v-model="addForm.noise" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>


            </el-col>
          </el-col>

          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="abdomen">
                腹部
              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="压痛">
                    <el-input v-model="addForm.pressPain" placeholder="请输入" clearable>

                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="包块">
                    <el-input v-model="addForm.masses" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="脾大">
                    <el-input v-model="addForm.splenauxe" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="肝大">
                    <el-input v-model="addForm.hepatomegaly" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="移动性浊音">
                    <el-input v-model="addForm.shiftingDullness" placeholder="请输入" clearable>

                    </el-input>
                  </el-form-item>
                </el-col>

              </el-col>
            </el-col>
          </el-col>

          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="label1">

              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="下肢水肿">
                    <el-input v-model="addForm.legsEdema" placeholder="请输入" clearable>

                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="足背动脉搏动">
                    <el-input v-model="addForm.dorsalFoot" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="肛门指诊">
                    <el-input v-model="addForm.anus" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="乳腺">
                    <el-input v-model="addForm.breast" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>


            </el-col>
          </el-col>


          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="gynecology">
                妇科
              </div>
            </el-col>
            <el-col :span="15" class="item">

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="外阴">
                    <el-input v-model="addForm.vulva" placeholder="请输入" clearable>

                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="阴道">
                    <el-input v-model="addForm.vagina" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="宫颈">
                    <el-input v-model="addForm.cervix" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="宫体">
                    <el-input v-model="addForm.corpus" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>

              <el-col :span="24" class="item">
                <el-col :span="12" class="item">
                  <el-form-item label="附件">
                    <el-input v-model="addForm.accessory" placeholder="请输入" clearable>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-col>
          </el-col>

          <el-col :span="24" class="item">
            <el-divider></el-divider>
            <el-col :span="2" class="item">
              <div class="examine">

                其他
              </div>
            </el-col>
            <el-col :span="20" class="item">


              <el-col :span="24" class="item">

                <el-input v-model="addForm.examine"
                          placeholder="请输入"
                          :rows="8"
                          type="textarea"
                          clearable>
                </el-input>
              </el-col>
            </el-col>

          </el-col>


        </el-card>


      </el-row>
    </el-form>
    <div style="background-color: white;height: 80px; width: 100% " v-show="!disabled">
      <div style="margin-left: 43.5%;margin-top: 10px; ">
        <el-button type="primary" style="width: 26%" @click="confirm('addForm')">保存</el-button>
      </div>
    </div>


  </div>


</template>

<script>

// import elderly from "@/common/status";
// import {timeStr,timefilters} from "@/common/times";
// import {hex_md5} from "@/common/Base64MD5";
// import {getStaffCode} from "@/utils/auth";
// import BaiduMap from "@/views/Elderly/BaiduMap";

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {


  name: "Role",
  data() {
    return {
        disabled:false,
      addForm: {
        timeStr: timeStr,
        sign : hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        staffCode: getStaffCode(),
        symptom: '',
        symptomInfo: '',
        temperature: '',
        respiratory: '',
        stature: '',
        weight: '',
        constitution:'',
        pulseRate: '',
        bloodPressureLeft: '',
        bloodPressureRight: '',
        healthStatus: '',
        cognitive: '',
        hipLine: '',
        waistLine: '',
        whr: '',
        selfCareAbility: '',
        emotionStates: '',
        workingTime: '',
        occupationalDiseases: '',
        occupationalDiseasesType: '',
        dust: '',
        dustSafeguard: '',
        radiogen: '',
        radiogenSafeguard: '',
        logistics: '',
        logisticsSafeguard: '',
        chemistry: '',
        chemistrySafeguard: '',
        occupationalDiseasesElse: '',
        occupationalDiseasesElseSafeguard: '',
        lip: '',
        tooth: '',
        pharynx: '',
        leftVision: '',
        rightVision: '',
        adjustLeftVision: '',
        adjustRightVision: '',
        hearing: '',
        athletic: '',
        skin: '',
        sclera: '',
        barrelChest: '',
        breathSounds: '',
        rale: '',
        heartRate: '',
        noise: '',
        pressPain: '',
        masses: '',
        splenauxe: '',
        hepatomegaly: '',
        shiftingDullness: '',
        legsEdema: '',
        dorsalFoot: '',
        anus: '',
        breast: '',
        vulva: '',
        vagina: '',
        cervix: '',
        corpus: '',
        accessory: '',
        examine: '',
        elderlyCode:''
      },
      elderlyCode:''

    }
  },
  created() {

  },
  components: {},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
    },
  },
  methods: {
    init(isSave, elData,disabled) {
        if(disabled)this.disabled=disabled
      this.isSave = isSave;
      this.elderlyCode = elData.elderlyCode;
      if(!this.isSave){
        this.$refs.addForm.resetFields();
      }else{
        this.getEHealth();
      }


    },
    confirm(addForm){
      if(!this.isSave){
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            this.addSubmit();
          } else {
            this.$message({type: 'warning', message: '请完善信息'});
            return false;
          }
        })
      }else {
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            this.editSubmit();
          } else {
            this.$message({type: 'warning', message: '请完善信息'});
            return false;
          }
        })
      }
    },
    addSubmit(){
      this.addForm.elderlyCode=this.elderlyCode;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "EHealthInfo/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '保存成功！'});
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },
    editSubmit(){
      this.addForm.elderlyCode=this.elderlyCode;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "EHealthInfo/Edit",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '保存成功！'});
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    getEHealth(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "EHealthInfo/GetEHealthInfo",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.elderlyCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              // this.elData=response.data.data;
              if(response.data.data){
                this.elData=response.data.data;
                this.dataInit();
              }else{
                this.isSave=false
              }
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    dataInit(){
      this.addForm.temperature=this.elData.temperature;
      this.addForm.respiratory=this.elData.respiratory;
      this.addForm.stature=this.elData.stature;
      this.addForm.weight=this.elData.weight;
      this.addForm.constitution=this.elData.constitution;
      this.addForm.pulseRate=this.elData.pulseRate;
      this.addForm.bloodPressureLeft=this.elData.bloodPressureLeft;
      this.addForm.bloodPressureRight=this.elData.bloodPressureRight;
      this.addForm.hipLine=this.elData.hipLine;
      this.addForm.waistLine=this.elData.waistLine;
      this.addForm.whr=this.elData.whr;
      this.addForm.selfCareAbility=this.elData.selfCareAbility;
      this.addForm.healthStatus=this.elData.healthStatus;
      this.addForm.symptom=this.elData.symptom;
      this.addForm.emotionStates=this.elData.emotionStates;
      this.addForm.workingTime=this.elData.workingTime;
      this.addForm.symptomInfo=this.elData.symptomInfo;
      this.addForm.occupationalDiseasesType=this.elData.occupationalDiseasesType;
      this.addForm.dust=this.elData.dust;
      this.addForm.dustSafeguard=this.elData.dustSafeguard;
      this.addForm.radiogen=this.elData.radiogen;
      this.addForm.radiogenSafeguard=this.elData.radiogenSafeguard;
      this.addForm.logistics=this.elData.logistics;
      this.addForm.logisticsSafeguard=this.elData.logisticsSafeguard;
      this.addForm.chemistry=this.elData.chemistry;
      this.addForm.chemistrySafeguard=this.elData.chemistrySafeguard;
      this.addForm.occupationalDiseasesElse=this.elData.occupationalDiseasesElse;
      this.addForm.occupationalDiseasesElseSafeguard=this.elData.occupationalDiseasesElseSafeguard;
      this.addForm.lip=this.elData.lip;
      this.addForm.tooth=this.elData.tooth;
      this.addForm.pharynx=this.elData.pharynx;
      this.addForm.leftVision=this.elData.leftVision;
      this.addForm.rightVision=this.elData.rightVision;
      this.addForm.adjustLeftVision=this.elData.adjustLeftVision;
      this.addForm.adjustRightVision=this.elData.adjustRightVision;
      this.addForm.cognitive=this.elData.cognitive;
      this.addForm.occupationalDiseases=this.elData.occupationalDiseases;
      this.addForm.skin=this.elData.skin;
      this.addForm.sclera=this.elData.sclera;
      this.addForm.barrelChest=this.elData.barrelChest;
      this.addForm.breathSounds=this.elData.breathSounds;
      this.addForm.rale=this.elData.rale;
      this.addForm.heartRate=this.elData.heartRate;
      this.addForm.noise=this.elData.noise;
      this.addForm.pressPain=this.elData.pressPain;
      this.addForm.masses=this.elData.masses;
      this.addForm.splenauxe=this.elData.splenauxe;
      this.addForm.hepatomegaly=this.elData.hepatomegaly;
      this.addForm.shiftingDullness=this.elData.shiftingDullness;
      this.addForm.legsEdema=this.elData.legsEdema;
      this.addForm.dorsalFoot=this.elData.dorsalFoot;
      this.addForm.anus=this.elData.anus;
      this.addForm.breast=this.elData.breast;
      this.addForm.vulva=this.elData.vulva;
      this.addForm.vagina=this.elData.vagina;
      this.addForm.cervix=this.elData.cervix;
      this.addForm.corpus=this.elData.corpus;
      this.addForm.accessory=this.elData.accessory;
      this.addForm.examine=this.elData.examine;
      this.addForm.athletic=this.elData.athletic;
      this.addForm.hearing=this.elData.hearing;
    },


  }
}
</script>

<style lang="scss" scoped>


.modal-HealthInfo {
    /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        border-color: #DCDFE6;
        color: #606266;
        cursor: not-allowed;
    }
    /deep/ .el-textarea.is-disabled .el-textarea__inner {
        background-color: #fff;
        border-color: #DCDFE6;
        color: #606266;
        cursor: not-allowed;
    }
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 300px;
    height: 300px;
    margin-top: 10px;
  }

  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  /deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 300px;
    line-height: 300px;
    text-align: center;
  }

  /deep/ .avatar {
    width: 300px;
    height: 300px;
    display: block;
  }

  /deep/ .el-card {
    box-shadow: none;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
  }

  .head {
    //border: 1px solid red;
    width: 100%;
    height: 150px;

    .head-left {
      //border: 1px solid red;
      width: 20%;
      display: inline-block;
      height: 80px;
      margin-top: 50px;
    }

    .head-right {
      //border: 1px solid red;
      width: 60%;
      display: inline-block;
      height: 100px;
      margin-left: 20px;
    }


  }
  .item{
    padding: 0 10px;
  }
  .occupationalDiseases {
    display: flex;
    align-items: center;
    height: 714px;
  }

  .oral {
    display: flex;
    align-items: center;
    height: 204px;
  }

  .vision {
    display: flex;
    align-items: center;
    height: 355px;
  }

  .label {
    display: flex;
    align-items: center;
    height: 102px;
  }

  .lung {
    display: flex;
    align-items: center;
    height: 204px;
  }

  .heart {
    display: flex;
    align-items: center;
    height: 102px;
  }

  .abdomen {
    display: flex;
    align-items: center;
    height: 355px;
  }

  .label1 {
    display: flex;
    align-items: center;
    height: 204px;
  }

  .gynecology {
    display: flex;
    align-items: center;
    height: 355px;
  }

  .examine{
    display: flex;
    align-items: center;
    height: 204px;
  }


}


</style>
